export default "query($countryIso: String!) {\n  territories {\n    states(countryIso: $countryIso) {\n      id\n      name\n    }\n  }\n}\n"